<template>
  <div id="index">
    <div class="contentBox indexBox">
      <div class="indexLeft">
        <div class="bannerBox">
          <bannerswiper :bannerList="indexData.banner"/>
        </div>
        <div class="newsBox">
          <div class="newsTitle">
            <img src="@/assets/images/newsIcon.png" class="newsicon">
            <p>News</p>
            <img src="@/assets/images/arrowRightIcon.png" class="arrowright">
          </div>
          <ul class="newsUl">
            <li v-for="(item,key) in indexData.news" :key="key">
              <div class="newsLeft">
                <p class="p1">{{item.day}}</p>
                <p class="p2">{{item.year}}{{item.mounth}}</p>
              </div>
              <div class="newsRight">
                <p class="title">
                  <!-- <router-link :to="{path:'/newsMain',params:{newsId:item.id}}" @click.native="gotonewsMainFn(item.id)">{{item.title}}</router-link> -->
                  <router-link :to="{name:'newsMain',params:{id:item.id}}">{{item.title}}</router-link>
                </p>
                <div class="newsMain">
                  <div class="newsMainImgBox">
                    <img :src="item.cover">
                  </div>
                  <div class="newsMainTextBox">
                    <p>{{item.description}}</p>
                  </div>
                </div>
                <div class="readMore">
                  <p>
                    <img src="@/assets/images/eyeIcon.png">
                    <span>{{item.view}}</span>
                    <router-link to="/news">More+</router-link>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="indexRight">
        <div class="userInfo" v-if="indexData.leader_info != {} ">
          <div class="userimgbox">
            <img :src="indexData.leader_info.header_img" class="userimg">
          </div>
          <p class="p1 mt-20">{{indexData.leader_info.name}}</p>
          <div class="mt-15">
            <img src="@/assets/images/emailIcon.png">
            <img src="@/assets/images/telIcon.png" class="ml-30">
          </div>
          <p class="p2 mt-20">{{indexData.leader_info.description}}</p>
          <!-- <p class="p2 mt-15">School of Chemistry and Chemical Engineering</p> -->
          <p class="p2 mt-15">Tel: {{indexData.leader_info.telephone}}</p>
          <p class="p2 mt-15">Email: {{indexData.leader_info.email}}</p>
        </div>
        <div class="hostArticles">
          <div class="titletop">
            <img src="@/assets/images/hostIcon.png">
            <p>Hot articles</p>
          </div>
          <ul class="articlesList" v-if="indexData.hot_article != {}">
            <li v-for="(item,key) in indexData.hot_article" :key="key">
              <div class="articlesimgBox">
                <img :src="item.cover" class="articlesimg">
              </div>
              <div class="articlesText">
                <router-link
                  :to="{name:'newsMain',params:{id:item.id}}"
                  @click.native="childLink(item.id)"
                >
                  <p class="p1">{{item.title}}</p>
                </router-link>
                <p class="p2">{{item.create_time}}</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="linksBox">
          <div class="titletop">
            <img src="@/assets/images/linksIcon.png" class="linksImg">
            <p>Links</p>
          </div>
          <ul class="linksUl">
            <li v-for="(item,key) in indexData.links" :key="key">
              <a target="_blank" :href="item.url">{{item.name}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import "@/assets/css/index.less";
import bannerswiper from "@/components/bannerswiper.vue";
import apiSign from "../assets/js/apiSign";
require("swiper/dist/css/swiper.css");
const monthDict = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "Aug",
  "09": "Sept",
  "10": "Oct",
  "11": "Nov",
  "12": "Dec"
};
export default {
  components: {
    bannerswiper
  },
  data() {
    return {
      indexData: {
        banner: [],
        news: [],
        hot_article: [],
        leader_info: {
          description: "",
          email: "",
          header_img: "",
          name: "",
          qq: "",
          telephone: "",
          wechat: ""
        },
        links: []
      }
    };
  },
  mounted() {
    this.setPageDate();
  },
  methods: {
    setPageDate() {
      let field = { rtime: apiSign.getTime() };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/home/index", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          if (resp.data.code) {
            this.$message({
              type: "error",
              message: resp.data.msg
            });
          } else {
            if ("banner" in resp.data.data) {
              this.indexData.banner = resp.data.data.banner;
            }
            if ("news" in resp.data.data) {
              Object.keys(resp.data.data.news).forEach(item => {
                resp.data.data.news[item].mounth =
                  monthDict[resp.data.data.news[item].create_time.slice(5, 7)];
                resp.data.data.news[item].year = resp.data.data.news[
                  item
                ].create_time.slice(0, 4);
                resp.data.data.news[item].day = resp.data.data.news[
                  item
                ].create_time.slice(8, 10);
              });
              this.indexData.news = resp.data.data.news;
            }
            if ("leader_info" in resp.data.data) {
              try {
                this.indexData.leader_info.name =
                  resp.data.data.leader_info.name;
                this.indexData.leader_info.header_img =
                  resp.data.data.leader_info.header_img;
                this.indexData.leader_info.description =
                  resp.data.data.leader_info.description;
                this.indexData.leader_info.email =
                  resp.data.data.leader_info.email;
                this.indexData.leader_info.telephone =
                  resp.data.data.leader_info.telephone;
              } catch (e) {
                console.error(e);
              }
            }
            if ("hot_article" in resp.data.data) {
              Object.keys(resp.data.data.hot_article).forEach(item => {
                resp.data.data.hot_article[item].mounth =
                  monthDict[resp.data.data.news[item].create_time.slice(5, 7)];
                resp.data.data.hot_article[item].year = resp.data.data.news[
                  item
                ].create_time.slice(0, 4);
                resp.data.data.hot_article[item].day = resp.data.data.news[
                  item
                ].create_time.slice(8, 10);
              });
              this.indexData.hot_article = resp.data.data.hot_article;
            }
            if ("links" in resp.data.data) {
              this.indexData.links = resp.data.data.links;
            }
          }
        });
    },

    childLink(id) {
      sessionStorage.setItem("newsid", id);
    }
  }
};
</script>
